import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

import {BaseSearchTabConfigModel} from "../../models/base-search-tab-config.model";

@Component({
    selector: "pcg-ng-tabs-landing",
    template: require('./tabs-landing.component.html')
})
export class TabsLandingComponent implements OnInit {
    @Input()
    public searchPageConfig: Array<BaseSearchTabConfigModel>;

    @Output()
    public tabChanged = new EventEmitter<BaseSearchTabConfigModel>();

    public constructor() { }

    public ngOnInit(): void {
    }

    private onTabClicked(event: Event, activeTab: BaseSearchTabConfigModel): void {
        event.preventDefault();
        this.tabChanged.emit(activeTab);
    }
}
